import React from "react";
import Tooltip from "@mui/material/Tooltip";
import icons from "../../../../../../constants/icons";
import * as Styles from "../../styles";
import { Lead } from "../../../../../../interfaces";

interface Props {
  item: Lead;
}

export const EmailCell: React.FC<Props> = ({ item }) => {
  const mails = [item.email1, item.email2, item.email3];
  const emailPrincipal = mails[(item.codigoEmailPrincipal || 1) - 1];

  return (
    <Tooltip
      followCursor
      arrow
      title={emailPrincipal || "Sem informação de e-mail"}
      placement="top-start"
    >
      <Styles.Td>
        <a
          target="_blank"
          rel="noreferrer"
          href={`mailto: ${emailPrincipal}`}
          style={{ display: "flex" }}
        >
          <img
            width={20}
            style={{ marginRight: 4 }}
            src={icons.outlookIcon}
            alt="icone outlook"
          />
          <p className="emailField">{emailPrincipal || "--"}</p>
        </a>
      </Styles.Td>
    </Tooltip>
  );
};
